import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import { KeyValueDefault } from "@/main/models/common";
import { ReassignForm } from "@/main/screens/order/reassignOrder/reassignScreenUtils";
import { isNullUndefined } from "@/main/services/reducerUtils";
import { getTranslateByKey } from "@/main/services/utils";
import { convertStringForBoolean } from "@/main/services/utilsString";
import { useReasonReducer } from "@/main/store/reason";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface IReasonCell {
	partIndex: number;
	hasAnyDecision: boolean;
}

const ID_BASE = "id-reassignOrder";

function ReasonCell({ partIndex, hasAnyDecision }: Readonly<IReasonCell>) {
	const { control, setValue } = useFormContext<ReassignForm>();
	const { reason: reasonReducer } = useReasonReducer();

	const reasonValue = useWatch({ control, name: `parts.${partIndex}.reason` });
	const showReasonDescription = !isNullUndefined(reasonValue) && convertStringForBoolean(reasonValue.default);

	return (
		<div
			role="presentation"
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "8px",
				width: "100%",
				alignSelf: "flex-start",
			}}
			onClick={(e) => e.stopPropagation()}
			onMouseDown={(e) => e.stopPropagation()}
		>
			<KogAutoCompleteControlled
				id={`${ID_BASE}-select-reason-${partIndex}`}
				nameCustom={`parts.${partIndex}.reason`}
				label={getTranslateByKey("information.reason")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={reasonReducer.data}
				isLoading={reasonReducer.isLoading}
				hideValue={isNullUndefined(reasonValue)}
				disabled={!hasAnyDecision}
				required={hasAnyDecision}
				rulesCustom={{ required: hasAnyDecision }}
				onChangeCustom={(option) => {
					if (option === null || !convertStringForBoolean((option as KeyValueDefault)?.default)) {
						setValue(`parts.${partIndex}.reasonDescription`, "");
					}
				}}
			/>

			{showReasonDescription && (
				<KogInputTextControlledNew
					id={`${ID_BASE}-input-reasonDescription-${partIndex}`}
					label={getTranslateByKey("information.description")}
					name={`parts.${partIndex}.reasonDescription`}
					control={control}
					required
					onChangeCustom={() => {}}
				/>
			)}
		</div>
	);
}

export default React.memo(ReasonCell);
